// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import "firebase/auth";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC_t9Jq9x2W_65mKFkK7XgUTz0RiCY_-TI",
  authDomain: "curry-king-prod-454216.firebaseapp.com",
  projectId: "curry-king-prod-454216",
  storageBucket: "curry-king-prod-454216.firebasestorage.app",
  messagingSenderId: "803543880665",
  appId: "1:803543880665:web:3a7896afb1a4a51c277fc8",
  measurementId: "G-GVGMB5BGL5"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * Generate Firebase Cloud Messaging token.
 * @returns {Promise<string | null>} FCM token or null if an error occurs.
 */

export const generateToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log("Notification Permission Status:", permission);
  
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BC_ZSTe1jdHglsQrRJUyxFqD4haZnh7fHZUD7dBuUDPlQcNl3p34C_lOmXBaBTEnKh-VxvW4obMZe4nGXgpDY_I",
      });
      if (token) {
        console.log("FCM Token Generated:", token);
        return token;
      }
    } else {
      alert(
        "Notifications are currently disabled. Open your browser settings and enable notifications for proper functionality."
      );
    } 
    console.error("Notification permission not granted.");
    return null;
  } catch (error) {
    console.error("Error generating FCM token:", error);
    return null;
  }
};

// export const generateToken = async () => {
//   try {
//     const permission = await Notification.requestPermission();
//     if (permission !== "granted") {
//       console.warn("Notification permission denied.");
//       return null;
//     }

//     console.log("Notification permission granted.");

//     const token = await getToken(messaging, {
//       vapidKey:
//         "BKdT-g9kO2f84VgMmnTzC0zwhD57t3HDB92xYTO3RY1uVCTYngsBMIyCkVf4vMNLAwMcLId0fvt4G5ssBJ-ST2Q",
//     });

//     if (token) {
//       console.log("FCM Token:", token);
//       return token;
//     } else {
//       console.warn("No FCM token available.");
//       return null;
//     }
//   } catch (error) {
//     console.error("Error generating FCM token:", error);
//     return null;
//   }
// };
